import React, { useEffect } from 'react';

const YandexMap = () => {
  useEffect(() => {
    // Инициализация карты после загрузки DOM
    if (window.ymaps) {
      window.ymaps.ready(() => {
        const map = new window.ymaps.Map('map', {
          center: [54.722773569965604,20.599393499999973], // Координаты
          zoom: 10,
        });

        const placemark = new window.ymaps.Placemark([54.722773569965604,20.599393499999973]);
        map.geoObjects.add(placemark);
      });
    }
  }, []);

  return <div id="map" style={{ height: '400px', width: '100%' }}></div>;
};

export default YandexMap;
